import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import InvoiceRepository from "~/repository/Invoice/InvoiceRepository";
import Invoice from "~/models/Invoice/Invoice";

class InvoiceStore extends NestStore {
  /**
   * @property {Array}
   */
  @observable invoices = [];

  /**
   * @property {Invoice}
   */
  @observable invoice;

  /**
   * @property {number}
   */
  invoiceId;

  invoiceRepository = null;

  constructor() {
    super();

    this.invoiceRepository = new InvoiceRepository();

    this.setDefaultSearchParams();
  }

  @action
  load() {
    this.isLoading = true;

    return Promise.all([this.getOne()]).then(() => {
      this.isLoading = false;
    });
  }

  @action
  getOne() {
    return this.invoiceRepository.fetchOne(this.invoiceId).then(response => {
      this.invoice = new Invoice(response.data.invoice);
    });
  }

  @action
  loadIndex() {
    this.isLoading = true;

    return Promise.all([this.getAll()]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll() {
    const params = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
    };

    if (this.searchParams.subscriptionId !== "") {
      params.subscriptionId = this.searchParams.subscriptionId;
    }

    return this.invoiceRepository.fetch(params).then(response => {
      this.processEntities(response.data.invoices);
      this.processPagination(response.data.pagination);
    });
  }

  @action
  processEntities(invoices = []) {
    this.invoices = [];

    invoices.forEach(invoiceArray => {
      const invoice = new Invoice(invoiceArray);

      this.invoices.push(invoice);
    });
  }

  /**
   * Change the pagination page and fetch the Photo Editing Jobs.
   */
  @action
  search() {
    this.pagination.currentPage = 1;

    return this.loadIndex();
  }

  /**
   * Set default search params.
   */
  @action
  setDefaultSearchParams() {
    this.searchParams.subscriptionId = "";
  }

  /**
   * Change the pagination page and fetch the Photo Editing Jobs.
   */
  @action
  changePage(page) {
    this.pagination.currentPage = page;

    return this.loadIndex();
  }
}

export default InvoiceStore;
